import { GET_LOADING_DATA } from "../actions/constants";

const initialState = {
  loading: false,
};

export default function loadingReducer(state = initialState, action) {
  switch (action.type) {
    case GET_LOADING_DATA:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
}
